import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useLocation,
  useNavigate
} from "react-router-dom";
import Layout from "./components/Layout";
import Dashboard from "./components/Dashboard";
import DashboardLoader from "./components/DashboardLoader";
import Login from "./components/Login";
import { AuthProvider, useAuth } from "./AuthContext"; // Ensure useAuth is exported from AuthContext
import HOReport from "./components/reports/HOReport";
import NW01 from "./components/reports/NW01";
import HST03 from "./components/reports/HST03";
import ComingSoon from "./components/ComingSoon";
import HST10 from "./components/reports/HST10";
import BI05 from "./components/reports/BI05";
import ST02 from "./components/reports/ST02";
import BI03 from "./components/reports/BI03";
import BM03 from "./components/reports/BM03";
import HY04 from "./components/reports/HY04";
import HY02 from "./components/reports/HY02";
import BI06 from "./components/reports/BI06";
import BI08 from "./components/reports/BI08";
import ST09 from "./components/reports/ST09";
import ST05 from "./components/reports/ST05";
import NW04 from "./components/reports/NW04";
import NW06 from "./components/reports/NW06";
import NW03 from "./components/reports/NW03";
import NW12 from "./components/reports/NW12";
import NW11 from "./components/reports/NW11";
import NW08 from "./components/reports/NW08";
import NW09 from "./components/reports/NW09";
import NW10 from "./components/reports/NW10";
import NW07 from "./components/reports/NW07";
import BL02 from "./components/reports/BL02";
import BM05 from "./components/reports/BM05";
import BL01 from "./components/reports/BL01";
import BL03 from "./components/reports/BL03";
import BI07 from "./components/reports/BI07";
import NW14 from "./components/reports/NW14";
import TL01 from "./components/reports/TL01";
import TL04 from "./components/reports/TL04";
import TL05 from "./components/reports/TL05";
import TL06 from "./components/reports/TL06";
import BI04 from "./components/reports/BI04";
import BM13 from "./components/reports/BM13";
import MS08 from "./components/reports/MS08";
import NewUser from "./components/NewUser";
import UserPermissions from "./components/UserPermissions"
import TL02 from "./components/reports/TL02";
import Users from "./components/Users";
import AllUsers from "./components/AllUsers";
import ChangePasswordOuter from "./components/ChangePasswordOuter";
import SM01 from "./components/reports/SM01";
import SM02 from "./components/reports/SM02";
import SM03 from "./components//reports/SM03";
import AB01 from "./components/reports/AB01";
import AB01EDIT from "./components/reports/AB01EDIT";
import AB01INIT from "./components/reports/AB01INIT";
import AB01VIEW from "./components/reports/AB01VIEW";
import ChemistAuditEdit from "./components/reports/ChemistAuditEdit";

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/change-password-outer" element={<ChangePasswordOuter />} />
          <Route path="/dashboard-loader" element={<DashboardLoader />} />
          {/* Apply the ProtectedRoute logic directly here */}
          <Route path="/" element={<ProtectedLayout />}>
            <Route path="/dashboard" element={<Dashboard />} />
             <Route path="/abm-report-01" element={<AB01 />} />
             <Route path="/abm-report-01-edit/:draftid" element={<AB01EDIT />} />
             <Route path="/abm-report-01-view/:draftid" element={<AB01VIEW />} />
              <Route path="/abm-report-chemist-audit/:auditreportid/:createdbyManager" element={<ChemistAuditEdit />} />
             <Route path="/abm-report-01-init" element={<AB01INIT />} />
            <Route path="/report-pending-pi" element={<BI04 />} />
            <Route path="/tools-new-user" element={<NewUser />} />
            <Route path="/tools-upload-files" element={<TL04 />} />
            <Route path="/tools-upload-files-tl05" element={<TL05 />} />
            <Route path="/coming-soon" element={<ComingSoon />} />
            <Route path="/report-product-wise-gross-net" element={<NW01 />} />
            <Route path="/report-selective-product-invoice-wise-details" element={<ST05 />} />
            <Route path="/selective-product-cumm-form6" element={<BM13 />} />
            <Route path="/selective-group-cumm-form6-22" element={<BM03 />} />
            <Route path="/report-product-group-wise-trend-bp-2" element={<NW03 />} />
            <Route path="/report-rupee-wise-performance" element={<NW04 />} />
            <Route path="/report-rupee-wise-gross-credit-net-sale" element={<NW06 />} />
            <Route path="/report-selective-group-brn-hq-wise-sales-trend" element={<NW07 />} />
            <Route path="/report-saleable-expiry-breakage" element={<NW08 />} />
            <Route path="/report-expiry-ratio" element={<NW09 />} />
            <Route path="/report-selective-group-product-wise-trend" element={<NW10 />} />
            <Route path="/report-sales-review-sp-1" element={<NW12 />} />
            <Route path="/report-rupee-wise-sales-analysis" element={<NW11 />} />
            <Route path="/tools-users" element={<TL01 />} />
            <Route path="/tools-change-password" element={<TL02 />} />
            <Route path="/report-daily-rp" element={<BL02 />} />
            <Route path="/report-day-wise-billing" element={<BL03 />} />
             <Route path="/report-ms08" element={<MS08 />} />
            <Route path="/daily-billing-entry" element={<BL01 />} />
            <Route path="/report-product-wise-sales-detail" element={<BI07 />} />
            <Route path="/settings-users" element={<Users />} />
            <Route path="/report-iqvia" element={<NW14 />} />
            <Route path="/settings-user-permissions-master" element={<AllUsers />} />
            <Route path="/report-product-wise-this-year-last-year" element={<BM05 />} />
            <Route path="/report-product-wise-details" element={<HOReport />} />
            <Route
              path="/report-stockist-wise-trend-gross-credit-net"
              element={<HST03 />}
            />
            <Route path="/settings-user-permissions/:uid/:name/:type" element={<UserPermissions />} />
            <Route
              path="/report-selective-product-stockiest-wise-trend"
              element={<HST10 />}
            />
            <Route
              path="/report-rupeeswise-salable-expiry-breakage"
              element={<BI03 />}
            />
            <Route
              path="/report-rupeeswise-gross-credit-net-sale"
              element={<BI05 />}
            />

            <Route
              path="/report-selective-product-hq-region-area-branch"
              element={<BI06 />}
            />
            <Route
              path="/report-selective-product-sales-trend-gross"
              element={<BI08 />}
            />


            <Route
              path="/report-selective-stockiest-product-wise-gross-credit-net-trend"
              element={<ST02 />}
            />
            <Route
              path="/report-selective-product-wise-stokiest-wise"
              element={<ST09 />}
            />
            <Route
              path="/tools-mtb-report"
              element={<TL06 />}
            />

            <Route
              path="/product-wise-sample-01"
              element={<SM01 />}
            />

            <Route
              path="/selective-product-sample-02"
              element={<SM02 />}
            />
             <Route
              path="/selective-product-sample-03"
              element={<SM03 />}
            />

            <Route
              path="/report-ho-neary-expiry-list"
              element={<HY04 />}
            />

            <Route
              path="/report-branchwise-near-expiry"
              element={<HY02 />}
            />


          </Route>

          <Route path="*" element={<Navigate to="/dashboard-loader" />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

const ProtectedLayout = () => {
  const location = useLocation();
  const navigate = useNavigate();

  if (location.pathname == "/") {
    navigate('/login');
  }

  const { isLoggedIn } = useAuth();
  const isAuth = isLoggedIn || localStorage.getItem("isLoggedIn") === "true";
  return isAuth ? <Layout /> : <Navigate to="/login" />;
};

export default App;
